// Auto-generated by scripts/copy-vendor.mjs — do not edit.
export const pagedjsScriptHref = "/vendor/pagedjs.f59f36180241.js" as const;
export const mermaidScriptHref = "/vendor/mermaid.18327bef70d9.js" as const;
